import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { OffCanvasService } from './off-canvas.service';

@Component({
	selector: 'app-off-canvas',
	templateUrl: './off-canvas.component.html',
	styleUrls: ['./off-canvas.component.css'],
})
export class OffCanvasComponent implements OnInit {
	isOpen: boolean;
	@Input() contentTemplate: TemplateRef<any>;
	constructor(private offCanvasService: OffCanvasService) {}

	ngOnInit(): void {
		this.offCanvasService.getState().subscribe((isOpen) => {
			this.isOpen = isOpen;
		});
	}

	close() {
		this.offCanvasService.close();
	}
}
